import { IconButton as MuiIconButton, Tooltip } from '@mui/material'

interface IconButtonProps {
  children: React.ReactNode
  onClick: any
  sx?: any
  style?: any
  size?: any
  edge?: any
  color?: any
  disabled?: boolean
  title?: string
  id?: any
}

export const IconButton = (props: IconButtonProps) => {
  const {
    children,
    onClick,
    sx,
    style,
    size,
    edge,
    color,
    disabled = false,
    title = '',
    id
  } = props

  return (
    <Tooltip title={title}>
      <MuiIconButton
        id={id}
        sx={sx}
        edge={edge}
        size={size}
        style={style}
        color={color}
        onClick={(event) => onClick(event)}
        disabled={!!disabled}
      >
        {children}
      </MuiIconButton>
    </Tooltip>
  )
}
